import React, { useEffect, useRef, useState } from "react";
import "./Home.css";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";
import hero_img1 from "../../image/iStock-1662841187.jpg";
import hero_img2 from "../../image/CSA image14.jpg";
import hero_img3 from "../../image/iStock-1160730376.jpg";
import hero_img4 from "../../image/iStock-1682253784.jpg";
import hero_img5 from "../../image/CSA image7.jpg";
import hero_img6 from "../../image/iStock-920044436.jpg";
import hero_img7 from "../../image/iStock-1682253784.jpg";
import hero_img8 from "../../image/CSA image2.jpg";
import empowering_img from "../../image/iStock-1319763851.jpg";
import hero_img01 from "../../image/iStock-1369101429.jpg";
import hero_img02 from "../../image/iStock-693469160.jpg";
import hero_img03 from "../../image/iStock-1562983249.jpg";
import Benefits_img from "../../image/iStock-1292575944.jpg";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import s1 from "../../image/iStock-1288148699.jpg";
import s2 from "../../image/iStock-1015863904.jpg";
import s3 from "../../image/iStock-1056271174.jpg";
import s4 from "../../image/iStock-1270067126.jpg";
import s5 from "../../image/iStock-1466995518.jpg";
import s6 from "../../image/iStock-1369917380.jpg";
import s7 from "../../image/CSA image9.jpg";

import AOS from "aos";
import "aos/dist/aos.css";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { APIURL, APIURLCOT } from "../../Config";
import axios from "axios";

export default function Home() {
  const [view, setView] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [showDownloadButton, setShowDownloadButton] = useState(false);
  const [show, setShow] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [callNow, setCallNow] = useState(false);

  const toggleItem = (index) => {
    console.log("index", index);
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };

  const initialValues = {
    name: "",
    contact: "",
    email: "",
    organisation: "",
    teamSize: "",
    message: "",
    recaptcha: false,
  };

  const faq = [
    {
      question:
        "What is Salarytap and how does it work for employers and employees?",
      answer:
        "Salarytap is a platform that allows employees to access their salary on demand. Employers can upload their employee data to the Salarytap workspace and set a maximum withdrawal limit for each employee. Once the setup is complete, employees can immediately access funds through the <a href='https://shorturl.at/93EjL' style='color: blue;'>Salarytap app</a>, available on the Google Play Store. Employees can withdraw funds 24/7.",
    },
    {
      question: "How do employers set up their workspace on Salarytap?",
      answer: `
      Salarytap is a platform that allows employees to access their salary on demand. Employers can upload their employee data to the Salarytap workspace and set a maximum withdrawal limit for each employee. Once the setup is complete, employees can immediately access funds through the Salarytap app, available on Google Play Store. Employees can withdraw funds instantly.
      `,
    },
    {
      question:
        "Can employers customise Salarytap in their HR App or use their own funds for advancing salary to their employees?",
      answer:
        "Salarytap can be customised to integrate with the employer’s HR app, and if employers prefer to use their own funds for advancing salary, they can integrate their bank account to fund their employees",
    },
    {
      question: "What will it cost the employees?",
      answer: `Employees incur a one-time setup fee of Rs. 300 at the time of their first withdrawal.<br/>
         There is no interest charged, but a flat convenience fee is applied to each withdrawal. `,
    },
    {
      question: "What is the cost of custom integration?",
      answer:
        "Integrating Salarytap into the employer's HR app or choosing to use the employer's funds to facilitate employee funding will cost approximately Rs. 3 to 5 lakhs for each integration.",
    },
    {
      question:
        "What are the steps for employers to enable their employees to withdraw funds?",
      answer:
        "First, you'll need to create your 'Workspace.' After completing your 'Profile,' your workspace will be set up. Once the backend is configured, we'll notify you. At that point, you can upload your employee list, and your employees will be able to start withdrawing funds immediately.",
    },
  ];

  const validationSchema = Yup.object({
    name: Yup.string().required("Required"),
    contact: Yup.string()
      .required("Required")
      .matches(/^[0-9]{10}$/, "Must be 10 digits"),
    email: Yup.string().email("Invalid email").required("Required"),
    organisation: Yup.string().required("Required"),
    teamSize: Yup.string().required("Required"),
    message: Yup.string(),
  });
  const handleClose = () => {
    setShow(false);
  };

  const handleSubmit = async (values, { resetForm }) => {
    const payload = {
      // or generate dynamically if needed
      name: values.name,
      mobileno: values.contact,
      emailid: values.email,
      organizationName: values.organisation,
      teamSize: parseInt(values.teamSize),
      message: values.message,
      entrydate: new Date().toISOString().split("T")[0], // "YYYY-MM-DD"
      entryby: "System",
    };

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${APIURL}/demoreports`,
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      data: payload,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        resetForm();
        setFormSubmitted(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const history = useNavigate();

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);

    // Initial check
    if (window.innerWidth < 768) {
      // Change this condition as needed
      setShowDownloadButton(true);
    } else {
      setShowDownloadButton(false);
    }

    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  const handleDownloadClick = () => {
    history("/salarytap/downloadpage"); // Redirect on button click
  };
  const sliderRef = useRef(null);
  const settings = {
    infinite: true,
    speed: 1000, // Adjust speed as needed
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    autoplay: true,
    autoplaySpeed: 5000, // Adjust autoplay speed as needed

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const [activeIndex, setActiveIndex] = useState(0);

  const slides = [
    {
      imgSrc: `${hero_img01}`,
      label:
        "Why should your employees need to borrow when they can simply use their own money?",
    },
    {
      imgSrc: `${hero_img02}`,
      label: "Making everyday payday for your employees",
    },
    {
      imgSrc: `${hero_img03}`,
      label: "Earn while you advance salaries to your employees.",
    },
  ];

  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <>
      <Navbar />

      <div className="">
        <Modal
          show={show}
          onHide={handleClose}
          size="lg"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>{formSubmitted ? "" : "Book a Demo"}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "20px" }}>
            {formSubmitted ? (
              <div className="text-center py-3">
                {callNow ? (
                  <div className="d-flex flex-column align-items-center">
                    <a
                      href="tel:+918146592004"
                      className="btn btn-primary mb-3"
                      style={{
                        backgroundColor: "#007bff",
                        border: "none",
                        color: "white",
                        padding: "12px 24px",
                        borderRadius: "5px",
                        textDecoration: "none",
                        fontSize: "16px",
                        width: "100%",
                        maxWidth: "200px",
                      }}
                    >
                      Call Now
                    </a>
                    <Button
                      variant="secondary"
                      onClick={handleClose}
                      style={{
                        width: "100%",
                        maxWidth: "200px",
                        padding: "10px",
                      }}
                    >
                      OK
                    </Button>
                  </div>
                ) : (
                  <>
                    <h4
                      className="text-success mb-3"
                      style={{ fontSize: "18px" }}
                    >
                      Thank you for your interest. Our executive will call you
                      shortly.
                    </h4>
                    <div className="card p-3 mb-3">
                      <p className="mb-4" style={{ fontSize: "16px" }}>
                        If you would like to speak to someone you may call{" "}
                        <b>8146592004</b>
                      </p>
                      <div className="d-flex justify-content-center gap-2">
                        <Button
                          variant="primary"
                          onClick={() => setCallNow(true)}
                          style={{
                            padding: "10px",
                            width: "100px",
                            fontSize: "14px",
                          }}
                        >
                          Yes
                        </Button>
                        <Button
                          variant="secondary"
                          onClick={handleClose}
                          style={{
                            padding: "10px",
                            width: "100px",
                            fontSize: "14px",
                          }}
                        >
                          No
                        </Button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            ) : (
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting }) => (
                  <Form>
                    <div className="form-group mb-3">
                      <Field
                        className="form-control"
                        name="name"
                        placeholder="Name *"
                        style={{ padding: "12px", fontSize: "16px" }}
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="text-danger small"
                      />
                    </div>

                    <div className="form-group mb-3">
                      <Field
                        className="form-control"
                        name="contact"
                        placeholder="Contact Number *"
                        style={{ padding: "12px", fontSize: "16px" }}
                      />
                      <ErrorMessage
                        name="contact"
                        component="div"
                        className="text-danger small"
                      />
                    </div>

                    <div className="form-group mb-3">
                      <Field
                        className="form-control"
                        name="email"
                        placeholder="Email Id *"
                        style={{ padding: "12px", fontSize: "16px" }}
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-danger small"
                      />
                    </div>

                    <div className="form-group mb-3">
                      <Field
                        className="form-control"
                        name="organisation"
                        placeholder="Organisation Name *"
                        style={{ padding: "12px", fontSize: "16px" }}
                      />
                      <ErrorMessage
                        name="organisation"
                        component="div"
                        className="text-danger small"
                      />
                    </div>

                    <div className="form-group mb-3">
                      <Field
                        className="form-control"
                        name="teamSize"
                        placeholder="Team Size *"
                        style={{ padding: "12px", fontSize: "16px" }}
                      />
                      <ErrorMessage
                        name="teamSize"
                        component="div"
                        className="text-danger small"
                      />
                    </div>

                    {/* <div className="form-group mb-3">
                      <Field
                        as="textarea"
                        className="form-control"
                        name="message"
                        placeholder="Message"
                        style={{
                          padding: "12px",
                          fontSize: "16px",
                          minHeight: "100px",
                        }}
                      />
                    </div> */}

                    <div className="text-center mt-4">
                      <Button
                        type="submit"
                        disabled={isSubmitting}
                        style={{
                          backgroundColor: "#77dd77",
                          border: "none",
                          width: "100%",
                          maxWidth: "200px",
                          padding: "12px",
                          fontSize: "16px",
                        }}
                      >
                        {isSubmitting ? "Submitting..." : "Submit"}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            )}
          </Modal.Body>
        </Modal>
        <div
          className="container"
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <div className=" px-lg-5 mt-2">
            <div
              className="container mb-2"
              data-aos="fade-up"
              data-aos-duration="3500"
            >
              {/* <div className="d-flex justify-content-center text-black fw-bold fs-2 w-100">
              <i> Empower your employees with on-demand salary access</i>
            </div> */}
            </div>
            <div
              id="carouselExampleCaptions"
              data-aos="fade-up"
              data-aos-duration="3500"
              className="carousel  container m-0 banner-height"
              // className="carousel slide carousel-fade container m-0 banner-height"

              data-ride="carousel"
              data-interval="3600"
              style={{
                position: "relative",
                width: "100%",
                height: "70vh",
              }}
            >
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <div
                    style={{
                      position: "relative",
                      backgroundColor: "black",
                      width: "100%",
                      height: "75vh",
                    }}
                  >
                    <div
                      className="custom-background"
                      style={{
                        position: "absolute",
                        backgroundColor: "#F5F5F5",
                        backgroundSize: "cover",
                        width: "100%",
                        height: "75vh",
                        display: "flex",
                        alignItems: "center",
                        backgroundImage: `url(${hero_img01})`,
                      }}
                    ></div>
                    <div className="img-text">
                      <div className="text-white fw-semibold fs-2 text-center">
                        Revolutionalising Employee Financial Wellness and
                        Retention
                      </div>

                      <div className="text-center mt-3">
                        <button
                          className="btn btn-primary"
                          style={{
                            width: "auto",
                            padding: "10px 20px",
                            borderRadius: "0.25rem",
                          }}
                          onClick={() => {
                            setShow(true);
                            setFormSubmitted(false);
                            setCallNow(false);
                          }}
                        >
                          Book a Demo
                        </button>
                      </div>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        bottom: "0%",
                        background:
                          "linear-gradient(356deg, #000 -10%, transparent)",
                        width: "100%",
                        height: "100%",
                        borderRadius: "0.25rem",
                      }}
                    />
                  </div>
                </div>

                <div className="carousel-item">
                  <div
                    style={{
                      position: "relative",
                      backgroundColor: "black",
                      width: "100%",
                      height: "75vh",
                    }}
                  >
                    <div
                      className="custom-background"
                      style={{
                        position: "absolute",
                        backgroundColor: "#F5F5F5",
                        backgroundSize: "cover",
                        width: "100%",
                        height: "75vh",
                        display: "flex",
                        alignItems: "center",
                        backgroundImage: `url(${hero_img02})`,
                      }}
                    ></div>
                    <div className="img-text">
                      <div className="text-white fw-semibold fs-2 text-center">
                        Empowering Teams, Enhancing Retention, Elevating
                        Performance
                      </div>

                      <div className="text-center mt-3">
                        <button
                          className="btn btn-primary"
                          style={{
                            width: "auto",
                            padding: "10px 20px",
                            borderRadius: "0.25rem",
                          }}
                          onClick={() => {
                            setShow(true);
                            setFormSubmitted(false);
                          }}
                        >
                          Book a Demo
                        </button>
                      </div>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        bottom: "0%",
                        background:
                          "linear-gradient(356deg, #000 -10%, transparent)",
                        width: "100%",
                        height: "100%",
                        borderRadius: "0.25rem",
                      }}
                    />
                  </div>
                </div>

                <div className="carousel-item">
                  <div
                    style={{
                      position: "relative",
                      backgroundColor: "black",
                      width: "100%",
                      height: "75vh",
                    }}
                  >
                    <div
                      className="custom-background"
                      style={{
                        position: "absolute",
                        backgroundColor: "#F5F5F5",
                        backgroundSize: "cover",
                        width: "100%",
                        height: "75vh",
                        display: "flex",
                        alignItems: "center",
                        backgroundImage: `url(${hero_img03})`,
                      }}
                    ></div>
                    <div className="img-text">
                      <h3 className="text-white text-center">
                        Early Salary Access powers 50 million globally — don’t
                        let your workforce miss out
                      </h3>

                      <div className="text-center mt-3">
                        <button
                          className="btn btn-primary"
                          style={{
                            width: "auto",
                            padding: "10px 20px",
                            borderRadius: "0.25rem",
                          }}
                          onClick={() => {
                            setShow(true);
                            setFormSubmitted(false);
                          }}
                        >
                          Book a Demo
                        </button>
                      </div>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        bottom: "0%",
                        background:
                          "linear-gradient(356deg, #000 -10%, transparent)",
                        width: "100%",
                        height: "100%",
                        borderRadius: "0.25rem",
                      }}
                    />
                  </div>
                </div>
              </div>

              <a
                className="carousel-control-prev"
                href="#carouselExampleCaptions"
                role="button"
                data-slide="prev"
                onClick={(e) => console.log(e)}
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="sr-only">Previous</span>
              </a>
              <a
                className="carousel-control-next"
                href="#carouselExampleCaptions"
                role="button"
                data-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="sr-only">Next</span>
              </a>
            </div>
          </div>
        </div>

        {/* <div className="container mt-2 px-lg-5 mb-2">
          <div
            id="carousel-1"
            className="carousel slide multi-item-carousel"
            data-ride="carousel"
          >
            <div className="carousel-inner" role="listbox">
              {slides.map((slide, index) => (
                <div
                  key={index}
                  className={`carousel-item ${
                    index === activeIndex ? "active" : ""
                  }`}
                >
                  <div className="mt-2 d-flex justify-content-center flex-column align-items-center">
                    <div className="container px-lg-5 mb-3">
                      <div className="d-flex text-black fw-bold fs-3 w-100">
                        {slide.label}
                      </div>
                    </div>
                    <div
                      className="container m-0 p-0 position-relative"
                      style={{ height: "75vh" }}
                    >
                      <div
                        className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center custom-background"
                        style={{ backgroundImage: `url(${slide.imgSrc})` }}
                      ></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <a
              className="carousel-control-prev"
              style={{ background: "transparent", top: "50%", bottom: "50%" }}
              role="button"
              data-slide="prev"
              onClick={goToPrevSlide}
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
            </a>
            <a
              className="carousel-control-next"
              role="button"
              style={{ background: "transparent", top: "50%", bottom: "50%" }}
              data-slide="next"
              onClick={goToNextSlide}
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
            </a>
          </div>
        </div> */}

        {/* <div className="container mt-2 px-lg-5 mb-2">
          <h5
            className="text-center fw-bolder fs-3 mb-4"
            style={{ color: "#000" }}
          >
            Empower your employees with on-demand salary access
          </h5>

          <div className="mt-2 d-flex justify-content-center">
            <div
              className="container-fluid m-0 p-0 position-relative"
              style={{ height: "75vh" }}
            >
              <div
                className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center custom-background"
                style={{
                  backgroundImage: `url(${hero_img01})`,
                }}
              >
                <div className="img-text">
                  <div className="d-flex text-white fw-semibold fs-2">
                    Why wait for payday!
                    <div className="text-white fw-semibold">...</div>
                  </div>
                  <div className="text-white fw-semibold">
                    instantly accessing their upcoming salary before it's due
                    date
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="">
          <div className="container  ">
            <div className="mt-5 mb-5 px-md-5">
              <div
                className="contain-box-first"
                data-aos="fade-up"
                data-aos-duration="3400"
              >
                <div className="card p-4">
                  <h2
                    className="fw-bold features osfe mb-5"
                    style={{
                      letterSpacing: "1px",
                      color: "#000",
                      borderBottom: "4px solid #66a725",
                      width: "40%",
                    }}
                  >
                    The Salarytap Advantage
                  </h2>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <div className="card h-100 text-center">
                        <div className="card-body">
                          <h5 className="card-title">What is Salarytap?</h5>
                          <p className="card-text">
                            A no-cost-to-employer platform offering instant
                            salary advances to employees, improving financial
                            resilience, job satisfaction, and overall workplace
                            wellbeing.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 mb-3">
                      <div className="card h-100 text-center">
                        <div className="card-body">
                          <h5 className="card-title">Why It Matters</h5>
                          <p className="card-text">
                            Studies show 72% of employees experience financial
                            stress, leading to lower productivity, higher
                            attrition, weaker loyalty, and reduced retention.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4 mb-3">
                      <div className="card h-100 text-center">
                        <div className="card-body">
                          <h5 className="card-title">
                            Core Benefits to Employers
                          </h5>
                          <p className="card-text text-start">
                            • Reduce attrition by up to <b>27%</b>
                            <br />• Boost employee engagement by <b>25%</b>
                            <br />• Improve productivity by <b>20%</b>
                            <br />• Strengthen loyalty and retention, creating a
                            more stable and committed workforce.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container my-5">
            <div
              className="row shadow"
              style={{
                borderRadius: "2rem",
                overflow: "hidden",
              }}
            >
              {/* Left Content */}
              <div
                className="col-md-7 bg-white p-4"
                style={{
                  borderTopLeftRadius: "2rem",
                  borderBottomLeftRadius: "2rem",
                }}
              >
                <h2
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    color: "#1c9c74",
                    marginBottom: "1.5rem",
                  }}
                >
                  Global Adoption & Proven Results
                </h2>
                <ul style={{ paddingLeft: "1.2rem" }}>
                  <li>
                    <strong>Walmart (USA):</strong> ~$200M saved annually via
                    reduced turnover
                  </li>
                  <li>
                    <strong>Tesla (USA):</strong> Uses EWA to retain workers
                  </li>
                  <li>
                    <strong>BT Group (UK):</strong> Increased employee
                    satisfaction
                  </li>
                </ul>
                <p style={{ marginTop: "1.5rem" }}>
                  <strong>50%</strong> less payday loan use,{" "}
                  <strong>40%</strong> better financial wellness ,{" "}
                  <strong>3.5x</strong> more job applications
                </p>
              </div>

              {/* Right with Image and Text Overlay */}
              <div
                className="col-md-5 p-0"
                style={{
                  position: "relative",
                  borderTopRightRadius: "2rem",
                  borderBottomRightRadius: "2rem",
                  overflow: "hidden",
                }}
              >
                <img
                  src={empowering_img}
                  alt="Placeholder"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(11, 175, 124, 0.9)",
                    color: "#fff",
                    padding: "2rem",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <h3 style={{ marginBottom: "1.5rem" }}>
                    India is Falling Behind
                  </h3>
                  <ul style={{ paddingLeft: "1.2rem" }}>
                    <li>
                      <strong>&lt;5%</strong> of Indian companies offer EWA
                    </li>
                    <li>Attrition cost: ~50-60% of annual salary </li>
                    <li>
                      <strong>67%</strong> of Indian workers report financial
                      anxiety
                    </li>
                    <li>
                      Now is the time to lead and align with global trends
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="container mb-5 px-md-5">
            <div
              className="contain-box-2"
              data-aos="fade-up"
              data-aos-duration="3400"
            >
              <div
                style={{
                  backgroundColor: "#f5fdf8",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#228b5c",
                    color: "white",
                    textAlign: "center",
                    padding: "20px",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                  }}
                >
                  FLEXIBLE MODELS TAILORED TO YOUR ORGANIZATION
                </div>

                <div className="container my-4">
                  <div className="row justify-content-center align-items-start">
                    {/* Left Side Numbers */}
                    <div className="col-md-1 d-flex flex-column align-items-center pt-2">
                      {[1, 2, 3].map((num) => (
                        <div
                          key={num}
                          style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                            backgroundColor: "#d9d9d9",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "bold",
                            fontSize: "20px",
                            margin: "30px 0",
                          }}
                        >
                          {num}
                        </div>
                      ))}
                    </div>

                    {/* Right Side Content Boxes */}
                    <div className="col-md-6">
                      <div
                        style={{
                          borderRadius: "10px",
                          backgroundColor: "#e7fff2",
                          padding: "15px",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ fontWeight: "bold", color: "#228b5c" }}>
                          Manual Integration
                        </div>
                        <p style={{ margin: 0 }}>
                          Easily upload monthly salary files; set fixed
                          withdrawal limits based on earned income.
                        </p>
                      </div>

                      <div
                        style={{
                          borderRadius: "10px",
                          backgroundColor: "#e7fff2",
                          padding: "15px",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ fontWeight: "bold", color: "#228b5c" }}>
                          API Integration
                        </div>
                        <p style={{ margin: 0 }}>
                          Seamlessly sync real-time salary, attendance, leave,
                          and notice period data; enable smart, dynamic limit
                          adjustments.
                        </p>
                      </div>

                      <div
                        style={{
                          borderRadius: "10px",
                          backgroundColor: "#e7fff2",
                          padding: "15px",
                          marginBottom: "30px",
                        }}
                      >
                        <div style={{ fontWeight: "bold", color: "#228b5c" }}>
                          HRMS Integration
                        </div>
                        <p style={{ margin: 0 }}>
                          Fully automated system connecting payroll, leave, and
                          attendance for smooth, hands-free operations.
                        </p>
                      </div>

                      <div>
                        <div
                          style={{
                            backgroundColor: "#228b5c",
                            color: "white",
                            textAlign: "center",
                            padding: "10px",
                            fontWeight: "bold",
                            borderRadius: "5px",
                            marginTop: "20px",
                          }}
                        >
                          Fully Customizable
                        </div>
                        <p style={{ marginTop: "10px" }}>
                          Configure withdrawal limits, approval workflows, and
                          feature sets to fit your company’s specific policies
                          and operational needs.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container mb-5 px-md-5">
            <div
              className="contain-box-2"
              data-aos="fade-up"
              data-aos-duration="3400"
            >
              <div className="my-3 mb-4">
                <h2
                  className="fw-bold features osfe"
                  style={{
                    letterSpacing: "1px",
                    borderBottom: "4px solid #66a725",
                    width: "39%",
                  }}
                >
                  Ontap Salary for Employees
                </h2>
              </div>

              <div className="row">
                <div
                  className="col-lg-3 col-md-3 col-sm-12 mt-3"
                  data-aos="fade-up"
                  data-aos-duration="3400"
                >
                  <div className="hover-img position-relative">
                    <div className="">
                      <img
                        src={hero_img1}
                        alt=""
                        width="100%"
                        height="450px"
                        className="rounded-1"
                        style={{
                          objectFit: "cover",
                        }}
                      />
                      <div className="overlay-gradient"></div>

                      <div
                        className="position-absolute"
                        style={{ bottom: "5%", width: "100%", zIndex: "99" }}
                      >
                        <div className="text-white text-center fw-bold d-flex justify-content-center text-wrap p-2 fs-3">
                          Log in
                        </div>
                        <div
                          className="mx-5"
                          style={{
                            borderBottom: "3px solid #66a725",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        />
                        <div className="text-show text-white text-center fw-medium d-flex justify-content-center text-wrap p-2 fs-5">
                          Log into Salarytap App with your mobile number
                        </div>
                        <div className="img-shadow d-flex"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-3 col-md-3 col-sm-12 mt-3"
                  data-aos="fade-up"
                  data-aos-duration="3400"
                >
                  <div className="hover-img position-relative">
                    <div className="">
                      <img
                        src={hero_img2}
                        alt=""
                        width="100%"
                        height="450px"
                        className="rounded-1"
                        style={{
                          objectFit: "cover",
                        }}
                      />
                      <div className="overlay-gradient"></div>
                      <div
                        className="position-absolute"
                        style={{ bottom: "5%", width: "100%", zIndex: "99" }}
                      >
                        <div className="text-white text-center fw-bold d-flex justify-content-center text-wrap p-2 fs-3">
                          Register
                        </div>
                        <div
                          className="mx-5"
                          style={{
                            borderBottom: "3px solid #66a725",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        />
                        <div className="text-show text-white text-center fw-medium d-flex justify-content-center text-wrap p-2 fs-5">
                          Register with Aadhaar, Pan and bank account.
                        </div>
                        <div className="img-shadow d-flex"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-3 col-md-3 col-sm-12 mt-3"
                  data-aos="fade-up"
                  data-aos-duration="3400"
                >
                  <div className="hover-img position-relative">
                    <div className="">
                      <img
                        src={hero_img3}
                        alt=""
                        width="100%"
                        height="450px"
                        className="rounded-1"
                        style={{
                          objectFit: "cover",
                        }}
                      />
                      <div className="overlay-gradient"></div>
                      <div
                        className="position-absolute"
                        style={{ bottom: "5%", width: "100%", zIndex: "99" }}
                      >
                        <div className="text-white text-center fw-bold d-flex justify-content-center text-wrap p-2 fs-3">
                          Withdraw funds
                        </div>
                        <div
                          className="mx-3"
                          style={{
                            borderBottom: "3px solid #66a725",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        />
                        <div className="text-show text-white text-center fw-medium d-flex justify-content-center text-wrap p-2 fs-5">
                          Instantly avail your limit and get funds in your bank
                          account or even use our QR code reader to make any
                          payment to third party.
                        </div>
                        <div className="img-shadow d-flex"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-3 col-md-3 col-sm-12 mt-3"
                  data-aos="fade-up"
                  data-aos-duration="3400"
                >
                  <div className="hover-img position-relative">
                    <div className="">
                      <img
                        src={hero_img4}
                        alt=""
                        width="100%"
                        height="450px"
                        className="rounded-1"
                        style={{
                          objectFit: "cover",
                        }}
                      />
                      <div className="overlay-gradient"></div>
                      <div
                        className="position-absolute"
                        style={{ bottom: "5%", width: "100%", zIndex: "99" }}
                      >
                        <div className="text-white text-center fw-bold d-flex justify-content-center text-wrap p-2 fs-3">
                          Repay
                        </div>
                        <div
                          className="mx-5"
                          style={{
                            borderBottom: "3px solid #66a725",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        />
                        <div className="text-show text-white text-center fw-medium d-flex justify-content-center text-wrap p-2 fs-5">
                          Your employer will deduct your monthly balance from
                          your salary and repay it. Once processed, your limit
                          will be restored for the next month.
                        </div>
                        <div className="img-shadow d-flex"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container mb-5 px-md-5">
            <div className="contain-box-3">
              <div
                className="my-3 mb-4"
                data-aos="fade-up"
                data-aos-duration="3400"
              >
                <h2
                  className="fw-bold features pricingemp"
                  style={{
                    letterSpacing: "1px",
                    borderBottom: "4px solid #66a725",
                    width: "30%",
                  }}
                >
                  Pricing for employees
                </h2>
              </div>
              <div className="row">
                <div
                  className="col-lg-4 col-md-4 col-sm-12 mt-3 "
                  data-aos="fade-up"
                  data-aos-duration="3400"
                  style={{ height: "300px" }}
                >
                  <div className="service-card shadow p-3 mb-5 rounded bg-white">
                    <div
                      className="text-center mt-3"
                      style={{ height: "40px" }}
                    >
                      <h3 className="b fs-5" style={{ fontSize: "16px" }}>
                        <b>One time set up fees </b>
                      </h3>
                    </div>
                    <div
                      className="mt-4 mb-4"
                      style={{ height: "115px", fontSize: "14px" }}
                    >
                      <div className="text-center" style={{ fontSize: "18px" }}>
                        A one time set up fee of Rs.300 is charged to the
                        employee on first withdrawal.
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-4 col-sm-12 mt-3"
                  data-aos="fade-up"
                  data-aos-duration="3400"
                  style={{ height: "300px" }}
                >
                  <div className="service-card shadow p-3 mb-5 rounded bg-white">
                    <div
                      className="text-center mt-3"
                      style={{ height: "40px" }}
                    >
                      <h3 className="b fs-5" style={{ fontSize: "16px" }}>
                        <b> Minimal Convenience Charges </b>
                      </h3>
                    </div>
                    <div
                      className="mt-4 mb-4"
                      style={{ height: "115px", fontSize: "14px" }}
                    >
                      <div className="text-center" style={{ fontSize: "18px" }}>
                        A small convenience fee is levied on every withdrawal.
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-4 col-sm-12 mt-3"
                  data-aos="fade-up"
                  data-aos-duration="3400"
                  style={{ height: "300px" }}
                >
                  <div className="service-card shadow p-3 mb-5 rounded bg-white">
                    <div
                      className="text-center mt-3"
                      style={{ height: "40px" }}
                    >
                      <h3 className="b fs-5" style={{ fontSize: "16px" }}>
                        <b> Interest Free </b>
                      </h3>
                    </div>
                    <div
                      className="mt-4 mb-4"
                      style={{ height: "115px", fontSize: "14px" }}
                    >
                      <div className="text-center" style={{ fontSize: "18px" }}>
                        No interest is levied on the withdrawals
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="px-md-5 pb-md-5">
              <div
                className="wrapper"
                data-aos="fade-up"
                data-aos-duration="3400"
              >
                <div className="mb-4">
                  <h2
                    className="fw-bold features"
                    style={{
                      letterSpacing: "1px",
                      borderBottom: "4px solid #66a725",
                      width: "12%",
                    }}
                  >
                    Features
                  </h2>
                </div>
                <Slider {...settings} ref={sliderRef}>
                  <div className="px-2 py-1 grid-box ">
                    <div className="position-relative grid">
                      <img
                        src={s1}
                        alt="Slide 1"
                        width="100%"
                        height="450px"
                        className="rounded-1 img-hover"
                        style={{
                          objectFit: "cover",
                        }}
                      />
                      <div
                        className="position-absolute"
                        style={{ bottom: "5%", width: "100%" }}
                      >
                        <div
                          className="text-white text-center fw-bold d-flex justify-content-center text-wrap p-2 fs-5"
                          style={{ zIndex: "99", position: "relative" }}
                        >
                          Instant withdrawal
                        </div>
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          bottom: "0%",
                          background:
                            "linear-gradient(356deg, #000 1%, transparent)",
                          width: "100%",
                          height: "100%",
                          borderRadius: "0.25rem",
                        }}
                      />
                    </div>
                  </div>
                  <div className="px-2 py-1 grid-box ">
                    <div className="position-relative grid">
                      <img
                        src={s2}
                        alt="Slide 2"
                        width="100%"
                        height="450px"
                        className="rounded-1 img-hover"
                        style={{
                          objectFit: "cover",
                        }}
                      />
                      <div
                        className="position-absolute"
                        style={{ bottom: "5%", width: "100%" }}
                      >
                        <div
                          className="text-white text-center fw-bold d-flex justify-content-center text-wrap p-2 fs-5"
                          style={{ zIndex: "99", position: "relative" }}
                        >
                          Month outstanding deducted from salary
                        </div>
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          bottom: "0%",
                          background:
                            "linear-gradient(356deg, #000 1%, transparent)",
                          width: "100%",
                          height: "100%",
                          borderRadius: "0.25rem",
                        }}
                      />
                    </div>
                  </div>
                  <div className="px-2 py-1 grid-box ">
                    <div className="position-relative grid">
                      <img
                        src={s3}
                        alt="Slide 3"
                        width="100%"
                        height="450px"
                        className="rounded-1 img-hover"
                        style={{
                          objectFit: "cover",
                        }}
                      />
                      <div
                        className="position-absolute"
                        style={{ bottom: "5%", width: "100%" }}
                      >
                        <div
                          className="text-white text-center fw-bold d-flex justify-content-center text-wrap p-2 fs-5"
                          style={{ zIndex: "99", position: "relative" }}
                        >
                          Interest-free credit line
                        </div>
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          bottom: "0%",
                          background:
                            "linear-gradient(356deg, #000 1%, transparent)",
                          width: "100%",
                          height: "100%",
                          borderRadius: "0.25rem",
                        }}
                      />
                    </div>
                  </div>
                  <div className="px-2 py-1 grid-box ">
                    <div className="position-relative grid">
                      <img
                        src={s4}
                        alt="Slide 4"
                        width="100%"
                        height="450px"
                        className="rounded-1 img-hover"
                        style={{
                          objectFit: "cover",
                        }}
                      />
                      <div
                        className="position-absolute"
                        style={{ bottom: "5%", width: "100%" }}
                      >
                        <div
                          className="text-white text-center fw-bold d-flex justify-content-center text-wrap p-2 fs-5"
                          style={{ zIndex: "99", position: "relative" }}
                        >
                          24/7 App support helpline
                        </div>
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          bottom: "0%",
                          background:
                            "linear-gradient(356deg, #000 1%, transparent)",
                          width: "100%",
                          height: "100%",
                          borderRadius: "0.25rem",
                        }}
                      />
                    </div>
                  </div>
                  <div className="px-2 py-1 grid-box ">
                    <div className="position-relative grid">
                      <img
                        src={s5}
                        alt="Slide 5"
                        width="100%"
                        height="450px"
                        className="rounded-1 img-hover"
                        style={{
                          objectFit: "cover",
                        }}
                      />
                      <div
                        className="position-absolute d-flex justify-content-center text-wrap"
                        style={{ bottom: "5%", width: "100%" }}
                      >
                        <div
                          className="text-white text-center fw-bold  d-flex justify-content-center text-wrap p-2 fs-5"
                          style={{ zIndex: "99", position: "relative" }}
                        >
                          Small convenience fee per withdrawal
                        </div>
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          bottom: "0%",
                          background:
                            "linear-gradient(356deg, #000 1%, transparent)",
                          width: "100%",
                          height: "100%",
                          borderRadius: "0.25rem",
                        }}
                      />
                    </div>
                  </div>
                  <div className="px-2 py-1 grid-box ">
                    <div className="position-relative grid">
                      <img
                        src={s6}
                        alt="Slide 6"
                        width="100%"
                        height="450px"
                        className="rounded-1 img-hover"
                        style={{
                          objectFit: "cover",
                        }}
                      />
                      <div
                        className="position-absolute"
                        style={{ bottom: "5%", width: "100%" }}
                      >
                        <div
                          className="text-white text-center fw-bold d-flex justify-content-center text-wrap p-2 fs-5"
                          style={{ zIndex: "99", position: "relative" }}
                        >
                          Set up fee of Rs.100 on first withdrawal
                        </div>
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          bottom: "0%",
                          background:
                            "linear-gradient(356deg, #000 1%, transparent)",
                          width: "100%",
                          height: "100%",
                          borderRadius: "0.25rem",
                        }}
                      />
                    </div>
                  </div>
                  <div className="px-2 py-1 grid-box">
                    <div className="position-relative grid">
                      <img
                        src={s7}
                        alt="Slide 7"
                        width="100%"
                        height="450px"
                        className="rounded-1 img-hover"
                        style={{
                          objectFit: "cover",
                        }}
                      />
                      <div
                        className="position-absolute"
                        style={{ bottom: "5%", width: "100%" }}
                      >
                        <div
                          className="text-white text-center fw-bold d-flex justify-content-center text-wrap p-2 fs-5"
                          style={{ zIndex: "99", position: "relative" }}
                        >
                          Secure and compliant
                        </div>
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          bottom: "0%",
                          background:
                            "linear-gradient(356deg, #000 1%, transparent)",
                          width: "100%",
                          height: "100%",
                          borderRadius: "0.25rem",
                        }}
                      />
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
